import * as ToggleMenuFlyoutEvent from '@ori-events/toggle-menu-flyout';

export const dispatchToggleMenu = (
  menuToggle: ToggleMenuFlyoutEvent.MenuTypes,
  activeMenu?: ToggleMenuFlyoutEvent.MenuTypes | '',
) => {
  const event = (menuType: ToggleMenuFlyoutEvent.MenuTypes) =>
    new CustomEvent<ToggleMenuFlyoutEvent.Data>(ToggleMenuFlyoutEvent.Name, {
      detail: {
        menuType,
      },
    });

  if (activeMenu && menuToggle !== activeMenu) {
    window.dispatchEvent(event(activeMenu));
  }

  requestAnimationFrame(() => {
    window.dispatchEvent(event(menuToggle));
  });
};
